<template>
    <div class="row flex-grow">
        <div class="col-lg-4 mx-auto">
            <div class="auth-form-light text-left pr-5 pb-5 pl-5">
                <div class="brand-logo text-right">
                    <img :src="'/media/aform-logo-black.png'" alt="Coachingclub.lu">
                </div>

                <h4>{{ $t('pages.login.title') }}</h4>
                <h6 class="font-weight-light">{{ $t('pages.login.subtitle') }}</h6>

                <form class="pt-3" @submit.prevent="login">
                    <div class="form-group">
                        <select class="form-control" v-model="$i18n.locale">
                            <option value="en">
                                {{ $t('languages.english') }}
                            </option>
                            <option value="de">
                                {{ $t('languages.german') }}
                            </option>
                            <option value="lb">
                                {{ $t('languages.luxembourgish') }}
                            </option>
                        </select>
                    </div>

                    <hr>

                    <div class="form-group">
                        <input type="email" id="email" class="form-control form-control-lg" :placeholder="$t('pages.login.email')" v-model="email">
                    </div>
                    <div class="form-group">
                        <input type="password" id="password" class="form-control form-control-lg" :placeholder="$t('pages.login.password')" v-model="password">
                    </div>
                    <div class="mt-4">
                        <button class="btn btn-block btn-outline-dark btn-lg font-weight-medium auth-form-btn" >
                            {{ $t('pages.login.sign_in') }}
                        </button>
                    </div>
                    <div class="my-2 d-flex justify-content-between align-items-center">
                        <router-link :to="{name: 'forgot-password'}" class="auth-link text-black">
                            {{ $t('pages.login.forgot_password') }}
                        </router-link>

                        <span class="font-weight-light">
                            {{ $t('pages.login.dont_have_an_account') }}
                            <router-link :to="{name: 'register'}" class="text-primary">
                                {{ $t('pages.login.create_account') }}
                            </router-link>
                        </span>
                    </div>
                </form>

                <div class="mt-4">
                    <hr>
                    <div class="row">
                        <div class="col-12">
                            <router-link tag="a" :to="{name: 'terms-and-conditions'}" class="text-muted">
                                {{ $t('pages.login.t_and_c') }}
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AuthRepository from "../../repositories/Auth/AuthRepository";
import store from "../../store/store";

export default {
    name: "Login",
    mounted() {
        AuthRepository.getSanctumCSRFCookie();
    },
    data: () => ({
        email: '',
        password: '',
    }),
    watch: {
        selectedLang(value, oldvalue) {
            this.$date.locale(value);
        }
    },
    computed: {
      selectedLang() {
          return this.$i18n.locale;
      }
    },
    methods: {
        login() {
            this.$store.dispatch("login", {
                email: this.email,
                password: this.password
            }).then((response) => {
                this.$snotify.success(`Welcome ${this.$store.getters.user.first_name}!`)
                this.$router.push({ name: 'home' });
            }).catch(error => {
                this.password = "";
            });
        }
    }
}
</script>

<style scoped>

</style>
